import { Component, Input } from '@angular/core';

export type StatusTone = 'success' | 'warning' | 'neutral' | 'solid-green' | 'custom';

@Component({
  selector: 'app-status-pill',
  template: `
    <span class="status-pill"
      [ngClass]="tone !== 'custom' ? 'status-pill--' + tone : ''"
      [ngStyle]="bgColor ? {'background-color': bgColor, 'color': textColor} : {}">
      <ng-content></ng-content>
    </span>
  `
})
export class StatusPillComponent {
  @Input() tone: StatusTone = 'neutral';
  @Input() bgColor: string | undefined = '';
  @Input() textColor: string | undefined = '';
}
